import styled from "styled-components";

export type StatusBadgeTone = "positive" | "attention" | "neutral" | "muted";

const TONE_COLORS: Record<
  StatusBadgeTone,
  { text: string; background: string }
> = {
  positive: {
    text: "var(--chip-text-success)",
    background:
      "color-mix(in srgb, var(--chip-text-success) 14%, var(--brand-white))",
  },
  attention: {
    text: "var(--ping-text-color)",
    background:
      "color-mix(in srgb, var(--ping-text-color) 12%, var(--brand-white))",
  },
  neutral: {
    text: "var(--brand-gray-700)",
    background: "var(--brand-gray-100)",
  },
  muted: {
    text: "var(--brand-gray-500)",
    background: "var(--brand-gray-100)",
  },
};

const BadgeStyled = styled.span<{ $tone: StatusBadgeTone }>`
  padding: 0.375rem 0.75rem;

  border-radius: 999px;
  background-color: ${({ $tone }) => TONE_COLORS[$tone].background};

  color: ${({ $tone }) => TONE_COLORS[$tone].text};
  font-size: 0.8125rem;
  font-weight: var(--font-weight-medium);
  white-space: nowrap;
`;

const DotStyled = styled.span`
  flex-shrink: 0;
  width: 6px;
  height: 6px;

  border-radius: 50%;
  background-color: currentColor;
`;

export function StatusBadge({
  label,
  tone,
}: {
  label: string;
  tone: StatusBadgeTone;
}) {
  return (
    <BadgeStyled $tone={tone} className="inline-flex align-items-center gap-2">
      <DotStyled />
      {label}
    </BadgeStyled>
  );
}
